import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import IconStackOverlay from '../../../../components/overlays/IconStackOverlay';
import { DEFAULT_LINK_CLASS_NAME } from '../../../../theme/constants/link';

const BaseAvailableOffersOverlay = ({
  title,
  overlayProps,
  titleProps,
  bodyProps,
}) => (
  <IconStackOverlay {...overlayProps}>
    <Typography {...titleProps}>
      {title}
    </Typography>
    <Typography {...bodyProps}>
      Revisa{' '}
      <Link
        component={RouterLink}
        to="/app/sales/factoring/available"
        className={DEFAULT_LINK_CLASS_NAME}
      >
        tus facturas disponibles
      </Link>{' '}
      para enviar a evaluar.
    </Typography>
  </IconStackOverlay>
);

BaseAvailableOffersOverlay.propTypes = {
  title: PropTypes.string.isRequired,
  overlayProps: PropTypes.shape({}),
  titleProps: PropTypes.shape({}),
  bodyProps: PropTypes.shape({}),
};

BaseAvailableOffersOverlay.defaultProps = {
  overlayProps: {},
  titleProps: { variant: 'h4', paragraph: true },
  bodyProps: { variant: 'body1', paragraph: true },
};

export default BaseAvailableOffersOverlay;
